import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import styles from './index.module.scss';
interface Props {
  text: string;
}
const Star = t0 => {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g fill="#aeb9c6"><path id="star" d="M10.471 5.267L8.453.964c-.118-.25-.415-.357-.665-.24-.106.05-.191.135-.24.24l-2.02 4.303-4.566.697c-.273.042-.46.297-.419.57.016.103.064.2.136.274L4 10.21l-.778 4.773c-.044.272.14.53.413.574.111.018.225-.002.323-.056L8 13.267l4.043 2.235c.242.133.546.046.68-.196.054-.098.074-.212.055-.322L12 10.21l3.32-3.403c.193-.198.19-.514-.008-.707-.075-.073-.17-.12-.274-.137l-4.567-.697z" /></g>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <svg viewBox="0 0 16 16" width="16" height="16" xmlns="http://www.w3.org/2000/svg" className={styles.star} aria-label={text}>{t1}</svg>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const Message = t0 => {
  const $ = _c(6);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("body-text", "small", styles.message);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <Star text={text} />;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== text) {
    t3 = <p className={t1}>{t2}{text}</p>;
    $[3] = t2;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};